import { GetStaticProps } from 'next';
import { FaqVariants } from '../../../../components/Common/FAQS';
import { ISTATIC_PAGE_PROPS } from '../../../../components/cms/layout/types';
import { generateComponent } from '../../../../components/cms/layout/util';
import {
  LANGUAGE_CODE,
  domainCode,
} from '../../../../constants/staticPageConstants';
import {
  partnerPageGenerate,
  partnerPagesPath,
} from '../../../../utils/static-pages/partnerPages';
import {
  staticPageGenerate,
  staticPagesPath,
} from '../../../../utils/static-pages/staticPages';

const CleartaxStaticPage = ({
  postData,
  metaData,
  pageType,
}: ISTATIC_PAGE_PROPS): JSX.Element => {
  return <>{generateComponent({ postData, pageType, metaData })}</>;
};

export const getStaticPaths = async () => {
  if (process.env.DEPLOYMENT_DOMAIN !== 'cleartax.in') {
    return {
      paths: [],
      fallback: false,
    };
  }
  if (process.env.ENABLE_PARTNER_PAGES === 'true') {
    const partnerPaths = await partnerPagesPath();
    return { ...partnerPaths };
  } else if (
    process.env.ENABLE_CALCULATOR_PAGES === 'true' ||
    process.env.PAGE_URL
  ) {
    const staticPaths = await staticPagesPath(
      LANGUAGE_CODE.English,
      domainCode.cleartaxIn,
      'fs-cache-dbs/cmsDATA.db',
      FaqVariants.calculator
    );
    return { ...staticPaths };
  } else if (
    process.env.ENABLE_CMS_PAGES === 'true' ||
    (process.env.PAGE_URL && process.env.PAGE_LANGUAGE === 'English')
  ) {
    const staticPaths = await staticPagesPath(
      LANGUAGE_CODE.English,
      domainCode.cleartaxIn
    );

    return { ...staticPaths };
  }
  return {
    paths: [],
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  if (process.env.ENABLE_PARTNER_PAGES === 'true') {
    const partnerPages = await partnerPageGenerate(params);
    return { ...partnerPages };
  } else if (process.env.ENABLE_CALCULATOR_PAGES === 'true') {
    const staticPages = await staticPageGenerate(
      params,
      LANGUAGE_CODE.English,
      'fs-cache-dbs/cmsDATA.db',
      FaqVariants.calculator
    );
    return { ...staticPages };
  } else if (process.env.ENABLE_CMS_PAGES === 'true' || process.env.PAGE_URL) {
    const staticPages = await staticPageGenerate(params);
    return { ...staticPages };
  } else {
    return {
      props: {
        postData: { title: '' },
        metaData: {},
        pageType: '',
      },
    };
  }
};

export default CleartaxStaticPage;
